import React from "react";
import { connect } from "react-redux";
import { Header, SelectedNecklaces } from "../../components";
import Footer from "../../components/Footer/Footer";
import "./_ConfiguratorPage.scss";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import {
  selectActiveNecklace,
  toggleNecklaceSelectModal,
} from "../../redux/actions";
import NecklaceSelector from "../../components/NecklaceSelector/NecklaceSelector";
import NecklaceSelectModal from "../../components/NecklaceSelectModal/NecklaceSelectModal";
import PriceDisplayNecklace from "../../components/PriceDisplay/PriceDisplayNecklace";

class ConfiguratorPageNecklace extends React.Component {
  componentDidMount() {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    // Select active necklace and memories depending on the query params.
    this.props.selectActiveNecklace(queryParams);
  }

  render() {
    const {
      pageTitleText,
      priceText,
      backButtonText,
      forwardButtonText,
      selectedItemsText,
      activeNecklace,
      activeMemories,
      selectNecklaceButtonText,
    } = this.props;
    return (
      <div className="configurator-page ojl-configurator-page">
        <Header titleText={pageTitleText} />
        <NecklaceSelector />
        <div className="necklace-select-button-container">
          <button
            className="necklace-select-button"
            onClick={() => this.props.toggleNecklaceSelectModal("necklace")}
          >
            {selectNecklaceButtonText}
          </button>
        </div>
        <div className="configurator-info">
          <SelectedNecklaces
            title={selectedItemsText}
            necklace={activeNecklace}
            memories={activeMemories}
          />
          <PriceDisplayNecklace title={priceText} />
        </div>
        <Footer
          backButtonText={backButtonText}
          forwardButtonText={forwardButtonText}
        />
        <NecklaceSelectModal />
      </div>
    );
  }
}

const mapStateToProps = ({ configuratorPageNecklace, necklace }) => {
  const {
    pageTitleText,
    selectNecklaceButtonText,
    selectMemoryButtonText,
    editButtonText,
    selectedItemsText,
    priceText,
    backButtonText,
    forwardButtonText,
  } = configuratorPageNecklace;

  const { activeNecklace, activeMemories } = necklace;

  return {
    pageTitleText,
    selectNecklaceButtonText,
    selectMemoryButtonText,
    editButtonText,
    selectedItemsText,
    priceText,
    backButtonText,
    forwardButtonText,
    activeNecklace,
    activeMemories,
  };
};

export default connect(mapStateToProps, {
  selectActiveNecklace,
  toggleNecklaceSelectModal,
})(withRouter(ConfiguratorPageNecklace));
